import { gql } from '@apollo/client'

import { ASSISTANT_FIELDS_FRAGMENT } from '../Assistant/fragments'

export const GET_THREADS_QUERY = gql`
  query GetThreads($workspaceId: String!) {
    threadsForUser(workspaceId: $workspaceId) {
      id
      workspaceId
      title
      avatarId
      avatarType
      assistantId
      assistantGoal
      createdAt
      authorization {
        workspace {
          isShared
        }
        users {
          id
          accessLevel
        }
      }
    }
  }
`

export const GET_THREADS_FOR_OBJECT_QUERY = gql`
  query GetThreadsForObject(
    $objectType: String!
    $objectId: String!
    $workspaceId: String!
  ) {
    threadsForObjectForUser(
      objectType: $objectType
      objectId: $objectId
      workspaceId: $workspaceId
    ) {
      id
      workspaceId
      title
      avatarId
      avatarType
      assistantId
      assistantGoal
      createdAt
    }
  }
`

export const GET_THREADS_FOR_ASSISTANT_QUERY = gql`
  query GetThreadsForAssistant($assistantId: String!, $workspaceId: String!) {
    threadsForAssistant(assistantId: $assistantId, workspaceId: $workspaceId) {
      id
      workspaceId
      title
      avatarId
      avatarType
      assistantId
      assistantGoal
      createdAt
    }
  }
`

export const GET_THREAD_QUERY = gql`
  query GetThread($id: String!, $workspaceId: String!) {
    thread(id: $id, workspaceId: $workspaceId) {
      id
      workspaceId
      title
      avatarId
      avatarType
      assistantId
      assistantGoal
      assistant {
        id
        firstName
        lastName
        photoUrl
        defaultLanguage
      }
      messages {
        id
        content
        type
        userId
        createdAt
        pages {
          id
          title
          contentHtml
          contentJson
          createdAt
          updatedAt
          ownerEmail
          crmObjects {
            objectId
            objectType
          }
          actionIds
          templateType
        }
        links {
          href
          text
        }
      }
      contextObjects {
        objectId
        objectType
      }
    }
  }
`

export const GET_CONTEXT_FOR_THREAD = gql`
  query ContextForThread(
    $threadId: String!
    $workspaceId: String!
    $objectReferences: [String!]
    $modelId: String
    $userTimezone: String
    $skipMetadataFallback: Boolean
  ) {
    contextForThread(
      threadId: $threadId
      workspaceId: $workspaceId
      objectReferences: $objectReferences
      modelId: $modelId
      userTimezone: $userTimezone
      skipMetadataFallback: $skipMetadataFallback
    ) {
      contextString
      tokenCount
    }
  }
`

export const GET_THREAD_WITH_CONTEXT = gql`
  query ThreadWithContext(
    $id: String!
    $workspaceId: String!
    $timezone: String
  ) {
    threadWithContext(id: $id, workspaceId: $workspaceId, timezone: $timezone) {
      thread {
        id
        workspaceId
        title
        avatarId
        avatarType
        assistantId
        assistantGoal
        modelId
        assistant {
          id
          firstName
          lastName
          photoUrl
          defaultLanguage
        }
        dismissedObjects {
          objectId
          objectType
          workspaceId
        }
        assistant {
          ...AssistantFields
        }
        assistantGoal
        messages {
          id
          content
          type
          userId
          createdAt
          pages {
            id
            title
            contentHtml
            contentJson
            createdAt
            updatedAt
            ownerEmail
            crmObjects {
              objectId
              objectType
            }
            actionIds
            templateType
          }
          links {
            href
            text
          }
        }
        contextObjects {
          objectId
          objectType
        }
        authorization {
          workspace {
            isShared
          }
          users {
            id
            accessLevel
          }
        }
      }
      context {
        contextString
        tokenCount
      }
      tools {
        id
        label
        description
        function {
          type
          function {
            name
            description
            parameters {
              type
              properties
              required
            }
          }
        }
      }
      instructions
    }
  }
  ${ASSISTANT_FIELDS_FRAGMENT}
`

export const GET_ORGANIZATION_COLOR = gql`
  query GetOrganizationColor($domain: String!, $workspaceId: String!) {
    workspaceOrganization(domain: $domain, workspaceId: $workspaceId) {
      colors {
        colorVibrant
      }
    }
  }
`

export const GET_TIPTAP_JWT = gql`
  query GetTiptapJwt($timestamp: Int!) {
    getTiptapJwt(timestamp: $timestamp)
  }
`

export const GET_THREAD_CONTEXT_OBJECTS = gql`
  query GetThreadContextObjects(
    $threadId: String!
    $workspaceId: String!
    $timezone: String
  ) {
    threadWithContext(
      id: $threadId
      workspaceId: $workspaceId
      timezone: $timezone
    ) {
      thread {
        id
        contextObjects {
          objectId
          objectType
          properties
          workspaceId
        }
      }
      context {
        contextString
        tokenCount
      }
    }
  }
`

export const ASSISTANT_TOOLS = gql`
  query AssistantTools($workspaceId: String!) {
    assistantTools(workspaceId: $workspaceId) {
      id
      label
      description
      function {
        type
        function {
          name
          description
          parameters {
            type
            properties
            required
          }
        }
      }
    }
  }
`

export const GET_CONTEXT_OBJECT_TEST = gql`
  query ContextObjectTest(
    $objectType: String!
    $objectId: String!
    $workspaceId: String!
  ) {
    contextObjectTest(
      objectType: $objectType
      objectId: $objectId
      workspaceId: $workspaceId
    ) {
      contextString
      tokenCount
    }
  }
`

export const GET_THREAD_MESSAGE = gql`
  query GetThreadMessage(
    $threadMessageId: String!
    $workspaceId: String!
    $threadId: String!
  ) {
    getThreadMessage(
      threadMessageId: $threadMessageId
      workspaceId: $workspaceId
      threadId: $threadId
    ) {
      id
      content
      type
      userId
      createdAt
      pages {
        id
        title
        contentHtml
        contentJson
        createdAt
        updatedAt
        ownerEmail
        crmObjects {
          objectId
          objectType
        }
        actionIds
        templateType
      }
      links {
        href
        text
      }
    }
  }
`
